<template>
   <div class="marginCon">
        <Card>
            <!-- 搜索 -->
            <div class="search-div">
               
    
                <DatePicker class="input-div" type="datetimerange" @on-change='selectT' format="yyyy-MM-dd HH:mm" :placeholder="$t('selectPlaceholder')" style="width: 300px"></DatePicker>
    
                <Button type="info" @click="searchItem"  icon="ios-search" style="width:96px;border-radius: 6px;">{{$t('search')}}</Button>
            </div>
            <div v-if="offModel">
                <Table max-height='770' style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>
        </Card>
   </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment'
import { mapState } from 'vuex'
    export default {
        name: "firmwareVersion",
        components: {
        },
        data(){
            return{
                loading: true,
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                searchObj:{
                    startTime:'',
                    endTime:''
                },
                tableList:{
                    tableData:[]
                },
              
               
            }
        },
        computed:{
             ...mapState(['local','selectId']),
             titleName(){
                 return [
                    {
                        title:this.$t('appDownload.titleName.id'),
                        'title-zh-CN':'编号',
                        'title-en-US':'Id',
                        key: 'id',
                        minWidth: 100,
                        sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('appDownload.titleName.downloadTime'),
                        'title-zh-CN':'下载时间',
                        'title-en-US':'Download time',
                        key: 'downloadTime',
                        minWidth: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.downloadTime*1).format('YYYY-MM-DD HH:mm:ss')
                            return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appDownload.titleName.userAccount'),
                        'title-zh-CN':'用户账号',
                        'title-en-US':'Account',
                        key: 'userAccount',
                        minWidth: 120
                    },
                    {
                        title:this.$t('appDownload.titleName.os'),
                        'title-zh-CN':'系统',
                        'title-en-US':'Operational system',
                        key: 'os',
                        minWidth: 180,
                        render:(h, params)=>{
                             let obj = {'1':'android','2':'ios'}
                             let stext = obj[params.row.os]
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appDownload.titleName.beforeDownVersion'),
                        'title-zh-CN':'之前版本',
                        'title-en-US':'Before version',
                        key: 'beforeDownVersion',
                        minWidth: 150
                    },
                   
                    {
                        title:this.$t('appDownload.titleName.afterDownVersion'),
                        'title-zh-CN':'现在版本',
                        'title-en-US':'Now version',
                        key: 'afterDownVersion',
                        minWidth: 130
                    }
                ]
             } 
        },
        created (){
            this.getData()
        },
       
        methods: {
            selectT(val){
  
               this.searchObj.startTime = val[0]?new Date(val[0]).getTime():""
               this.searchObj.endTime = val[1]?new Date(val[1]).getTime():""
            },
            searchItem(){
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 15
                this.getData()
            },
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId,
                        ...this.searchObj
                    }
                }
                this.axios.post(this.config.urlArray.appDownRecordsList,getData.params).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data.downRecordList
                    //处理数组
                    if(resData){
                        this.tableList.tableData = resData  //渲染数据
                        this.page.total = result.data.data.meta.count
                        this.loading = false
                    }else{
                        return false
                    }
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            }
        }
    }
</script>



